import { API_PATHS } from '@/api';
import { getData, postData } from '@/api/crudHandlers';
import {
  PushCommunicationListResponse,
  PushCommunicationFilters,
  SendPushCommunicationRequest,
  SendPushCommunicationResponse,
  TAxiosResponseSuccess,
} from '@/types';

export const communicationHandlers = {
  SEND_PUSH(
    data: SendPushCommunicationRequest,
  ): TAxiosResponseSuccess<SendPushCommunicationResponse> {
    const formData = new FormData();
    formData.append('pushTitle', data.pushTitle);
    formData.append('pushText', data.pushText);
    if (data.note) {
      formData.append('note', data.note);
    }
    formData.append('file', data.file);

    return postData<SendPushCommunicationResponse>(API_PATHS.COMMUNICATION.SEND_PUSH._, {
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  GET_HISTORY(params?: {
    page?: number;
    take?: number;
    filters?: PushCommunicationFilters;
  }): TAxiosResponseSuccess<PushCommunicationListResponse> {
    return getData<PushCommunicationListResponse>(API_PATHS.COMMUNICATION.HISTORY._, {
      params: {
        page: params?.page || 1,
        take: params?.take || 10,
        ...(params?.filters?.status && { status: params.filters.status }),
        ...(params?.filters?.startDate && { startDate: params.filters.startDate }),
        ...(params?.filters?.endDate && { endDate: params.filters.endDate }),
      },
    });
  },
};
